// @flow
import * as React from 'react';
import Card from 'sail/Card';
import Box from 'sail/Box';
import './NoCodeCta.scss';

type NoCodeCtaProps = {|
  children: React.Node,
|};

export const NoCodeCta = ({children}: NoCodeCtaProps) => {
  return (
    <Card shadow="keyline" className="NoCodeCta">
      <Box padding={12}>{children}</Box>
    </Card>
  );
};
